import { generateId } from '../utils/vsmGeometry';

export interface PresetRole {
  name: string;
  costPerHour: number;
  quantity: number;
  visible: boolean;
}

export interface PresetDepartment {
  name: string;
  color: string;
  roles: PresetRole[];
  visible: boolean;
}

export const DEFAULT_ORGANIZATION_PRESET: PresetDepartment[] = [
  {
    name: 'Produção',
    color: '#3B82F6',
    visible: true,
    roles: [
      { name: 'Operador de Produção', costPerHour: 25, quantity: 10, visible: true },
      { name: 'Supervisor de Produção', costPerHour: 45, quantity: 2, visible: true },
      { name: 'Gerente de Produção', costPerHour: 80, quantity: 1, visible: true },
      { name: 'Técnico de Manutenção', costPerHour: 35, quantity: 3, visible: true },
      { name: 'Auxiliar de Produção', costPerHour: 20, quantity: 5, visible: true },
    ]
  },
  {
    name: 'Logística',
    color: '#10B981',
    visible: true,
    roles: [
      { name: 'Almoxarife', costPerHour: 28, quantity: 3, visible: true },
      { name: 'Operador de Empilhadeira', costPerHour: 30, quantity: 4, visible: true },
      { name: 'Supervisor de Logística', costPerHour: 42, quantity: 1, visible: true },
      { name: 'Auxiliar de Expedição', costPerHour: 22, quantity: 2, visible: true },
      { name: 'Conferente', costPerHour: 24, quantity: 2, visible: true },
    ]
  },
  {
    name: 'Qualidade',
    color: '#F59E0B',
    visible: true,
    roles: [
      { name: 'Inspetor de Qualidade', costPerHour: 32, quantity: 3, visible: true },
      { name: 'Analista de Qualidade', costPerHour: 50, quantity: 2, visible: true },
      { name: 'Gerente de Qualidade', costPerHour: 75, quantity: 1, visible: true },
      { name: 'Auditor Interno', costPerHour: 55, quantity: 1, visible: true },
    ]
  },
  {
    name: 'Manutenção',
    color: '#8B5CF6',
    visible: true,
    roles: [
      { name: 'Mecânico', costPerHour: 38, quantity: 4, visible: true },
      { name: 'Eletricista', costPerHour: 40, quantity: 3, visible: true },
      { name: 'Supervisor de Manutenção', costPerHour: 50, quantity: 1, visible: true },
      { name: 'Auxiliar de Manutenção', costPerHour: 25, quantity: 2, visible: true },
    ]
  },
  {
    name: 'Engenharia',
    color: '#EC4899',
    visible: true,
    roles: [
      { name: 'Engenheiro de Processos', costPerHour: 85, quantity: 2, visible: true },
      { name: 'Engenheiro Industrial', costPerHour: 90, quantity: 1, visible: true },
      { name: 'Técnico de Processos', costPerHour: 45, quantity: 2, visible: true },
      { name: 'Analista de Melhoria Contínua', costPerHour: 55, quantity: 1, visible: true },
    ]
  },
  {
    name: 'Planejamento (PCP)',
    color: '#14B8A6',
    visible: true,
    roles: [
      { name: 'Analista de PCP', costPerHour: 48, quantity: 2, visible: true },
      { name: 'Programador de Produção', costPerHour: 42, quantity: 2, visible: true },
      { name: 'Supervisor de PCP', costPerHour: 58, quantity: 1, visible: true },
    ]
  },
  {
    name: 'Comercial',
    color: '#06B6D4',
    visible: true,
    roles: [
      { name: 'Vendedor', costPerHour: 35, quantity: 5, visible: true },
      { name: 'Gerente Comercial', costPerHour: 70, quantity: 1, visible: true },
      { name: 'Analista Comercial', costPerHour: 45, quantity: 2, visible: true },
      { name: 'Representante de Vendas', costPerHour: 38, quantity: 3, visible: true },
    ]
  },
  {
    name: 'Administrativo',
    color: '#64748B',
    visible: true,
    roles: [
      { name: 'Assistente Administrativo', costPerHour: 28, quantity: 3, visible: true },
      { name: 'Analista Administrativo', costPerHour: 40, quantity: 2, visible: true },
      { name: 'Gerente Administrativo', costPerHour: 65, quantity: 1, visible: true },
      { name: 'Recepcionista', costPerHour: 22, quantity: 2, visible: true },
    ]
  },
  {
    name: 'Financeiro',
    color: '#EAB308',
    visible: true,
    roles: [
      { name: 'Analista Financeiro', costPerHour: 52, quantity: 2, visible: true },
      { name: 'Contador', costPerHour: 68, quantity: 1, visible: true },
      { name: 'Auxiliar Financeiro', costPerHour: 30, quantity: 2, visible: true },
      { name: 'Gerente Financeiro', costPerHour: 85, quantity: 1, visible: true },
    ]
  },
  {
    name: 'Recursos Humanos',
    color: '#F97316',
    visible: true,
    roles: [
      { name: 'Analista de RH', costPerHour: 45, quantity: 2, visible: true },
      { name: 'Gerente de RH', costPerHour: 70, quantity: 1, visible: true },
      { name: 'Assistente de DP', costPerHour: 32, quantity: 1, visible: true },
      { name: 'Recrutador', costPerHour: 38, quantity: 1, visible: true },
    ]
  },
];

// Função para converter preset em organização real
export const createOrganizationFromPreset = () => {
  const departments = DEFAULT_ORGANIZATION_PRESET.filter(d => d.visible).map(dept => ({
    id: generateId(),
    name: dept.name,
    color: dept.color,
    totalHeadcount: dept.roles.filter(r => r.visible).reduce((sum, r) => sum + r.quantity, 0),
    visible: true,
    shiftMinutes: 480,
    shiftsPerDay: 1,
  }));

  const roles: any[] = [];
  DEFAULT_ORGANIZATION_PRESET.filter(d => d.visible).forEach((dept, deptIndex) => {
    const departmentId = departments[deptIndex].id;
    dept.roles.filter(r => r.visible).forEach(role => {
      roles.push({
        id: generateId(),
        name: role.name,
        departmentId,
        costPerHour: role.costPerHour,
        currency: 'BRL',
        quantity: role.quantity,
        visible: role.visible,
      });
    });
  });

  return { departments, roles };
};
